import { render, staticRenderFns } from "./order-confirmation-template-selector.vue?vue&type=template&id=d39b62e8&scoped=true&"
import script from "./order-confirmation-template-selector.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-template-selector.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-template-selector.vue?vue&type=style&index=0&id=d39b62e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39b62e8",
  null
  
)

export default component.exports